<template>
  <article class="ask-and-answer-container">
    <div class="ask-container">
      <img
        :src="askIcon"
        class="ask-icon"
        alt="ask">
      <div class="ask-bubble">
        <p class="ask-text" v-if="question" v-html="question" />
        <slot name="ask"></slot>
      </div>
    </div>
    <div class="answer-container">
      <div class="answer-bubble">
        <p class="answer-text" v-if="answer" v-html="answer" />
        <slot name="answer"></slot>
      </div>
      <img
        :src="answerIcon"
        class="answer-icon"
        alt="ask">
    </div>
  </article>
</template>

<script>
const askIcon = require('@/assets/images/icons/ask.svg');
const answerIcon = require('@/assets/images/icons/customer-service.svg');

export default {
  props: {
    question: {
      type: String,
      default: () => '',
    },
    answer: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      askIcon,
      answerIcon,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.ask-and-answer-container {
  padding: 20px 0 60px;
  .ask-container {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: center;
    .ask-icon {
      width: 50px;
      margin-right: 10px;
      margin-bottom: -20px;
    }
    .ask-bubble {
      position: relative;
      border-radius: 20px;
      padding: 8px 15px;
      background-color: #29292d;
      .ask-text {
        font-size: $h4-font-size;
        color: #FFF;
        margin: 0;
      }
      &::before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 0;
        left: -7px;
        height: 20px;
        width: 20px;
        background: #29292d;
        border-bottom-right-radius: 15px;
      }
      &::after {
        content: "";
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: -10px;
        width: 10px;
        height: 20px;
        background: #343439;
        border-bottom-right-radius: 10px;
      }
    }
  }
  .answer-container {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: $spacer;
    .answer-icon {
      width: 50px;
      margin-left: 10px;
      margin-bottom: -20px;
    }
    .answer-bubble {
      position: relative;
      border-radius: 20px;
      padding: 20px 15px;
      background-color: #676767;
      max-width: 618px;
      .answer-text {
        color: #FFF;
        margin: 0;
        text-align: left;
      }
      a {
        &:hover {
          color: #83c0ff;
        }
      }
      &::before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 0;
        right: -8px;
        height: 20px;
        width: 20px;
        background: #676767;
        border-bottom-left-radius: 15px;
      }
      &::after {
        content: "";
        position: absolute;
        z-index: 1;
        bottom: 0;
        right: -10px;
        width: 10px;
        height: 20px;
        background: #343439;
        border-bottom-left-radius: 10px;
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .ask-and-answer-container {
    .ask-container {
      .ask-icon {
        width: 40px;
      }
      .ask-bubble {
        .ask-text {
          font-size: $h5-font-size;
        }
      }
    }
    .answer-container {
      .answer-icon {
        width: 40px;
        margin-left: 10px;
        margin-bottom: -20px;
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .ask-and-answer-container {
    .ask-container {
      .ask-icon {
        width: 36px;
      }
      .ask-bubble {
        .ask-text {
          font-size: $font-size-base * 1.15;
        }
      }
    }
    .answer-container {
      .answer-icon {
        width: 36px;
      }
    }
  }
}
</style>
